// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__OZFKv","Cercle":"Slider_Cercle__NOEA6","active":"Slider_active__-KeSH"};